<template>
  <div v-if="store.isNewsLoading">
    <LoaderFullPage />
  </div>

  <template v-else-if="store.lobbiesNews?.length">
    <div class="lobby-news-wrapper" :class="{ zoomed: !isFollawed }">
      <template
        v-for="item in store.lobbiesNews"
        :key="item._id || item.id_twitter"
      >
        <PublicationCard
          v-if="Object.values(Platforms).includes(item.data_type)"
          :post="item"
        />
        <XArticleCard v-if="item.type === 'article'" :article="item" />
        <QuestionCard
          v-if="item.type === 'question'"
          :question="item"
          :to="`/lobbies/${route.params._id || 'follawed'}/question/${item._id}`"
        />
        <EventCard v-if="item.type === 'event'" :event="item" />
        <ReportCard v-if="item.type === 'compte_rendu'" :report="item" />
      </template>
    </div>
    <div class="pagination-wrapper">
      <PaginationElement
        v-if="totalCount"
        :key="`${totalCount}${store.selectedLobbiesNewsParams.from}${store.selectedLobbiesNewsParams.size}`"
        :total-items="totalCount"
        :current-page="store.selectedLobbiesNewsParams.from"
        :items-limit="store.selectedLobbiesNewsParams.size"
        @change-current-page="changeCurrentPage"
      />
    </div>
  </template>

  <div v-else class="card">
    <EmptySection :message="emptyMessage" />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import XArticleCard from "@follaw-fr/components/social-media/molecules/XArticleCard.vue";
import QuestionCard from "@follaw-fr/components/questions/atoms/QuestionCard.vue";
import EventCard from "@follaw-fr/components/agenda/organisms/EventCard.vue";
import ReportCard from "@follaw-fr/components/legi-reports/molecules/ReportCard.vue";
import PaginationElement from "@follaw-fr/components/reusable/atoms/PaginationElement.vue";
import EmptySection from "@follaw-fr/components/reusable/molecules/EmptySection.vue";
import { useLobbiesStore } from "@follaw-fr/stores/lobbies";
import PublicationCard from "@follaw-fr/components/social-media/posts/molecules/PublicationCard.vue";
import { Platforms } from "@follaw-fr/utils/social360-platforms.js";

const store = useLobbiesStore();
const route = useRoute();

const isFollawed = ref(route.fullPath.includes("follawed") ? true : false);

const emptyMessage = computed(() => {
  return isFollawed.value
    ? "Vos organisations follawed n'ont pas d'actualités."
    : "Cette organisation n'a pas d'actualités.";
});

const totalCount = computed(() => {
  let count = 0;
  Object.values(store.newsCounts).forEach((c) => {
    count += c;
  });
  return count;
});

const changeCurrentPage = (from) => {
  store.selectedLobbiesNewsParams.from = from;
  if (isFollawed.value) {
    store.fetchFollawedNews();
  } else {
    store.readOneLobbyNews(route.params._id);
  }
};
</script>

<style lang="scss" scoped>
.lobby-news-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  &.zoomed {
    display: flex;
    flex-direction: column;
  }
}

.pagination-wrapper {
  grid-column: span 2;

  @container (max-width: 1100px) {
    grid-column: span 1;
  }
}
</style>
